module.exports = __webpack_public_path__ + "img/1457509833.85b2b7e7.jpg";